export const paginationLimits = [
  { id: 5, label: "5" },
  { id: 10, label: "10" },
  { id: 20, label: "20" },
  { id: 50, label: "50" },
  { id: 100, label: "100" },
  { id: -1, label: "All" },
];
